import { render } from "./EventCard.vue?vue&type=template&id=615bbb7d&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=615bbb7d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-615bbb7d"

export default script